import React, {useState} from "react";
import {getIdWithToken} from "../../../utils/storage/Token";
import {CallbackErrorModalFL, CallbackFinishedModalFL} from "../../Dashboard/Form/ModalForm";
import StatusDeclaration, {TypeStatusDeclaration} from "../../../utils/Business/StatusDeclaration";
import {UpdateChangeStatusDeclarationTVA} from "../../../service/Business/DeclarationService";
import {DeclarationTVAResumeInterface} from "../../../service/Business/Interfaces/DeclarationInterface";
import {useToast} from "../../FCObjets/FCToast/FCToast";
import TypeDate from "../../../types/TypeDate";
import formatEuro from "../../../utils/formatEuro";
import "./FormAtelier.scss";

type FormDeclarationTVAProps = {
    onFinished: CallbackFinishedModalFL;
    onError: CallbackErrorModalFL;
    decTVA: DeclarationTVAResumeInterface;
};

const FormDeclarationTVA: React.FunctionComponent<FormDeclarationTVAProps> = (props) => {
    const toast = useToast();
    const [inputState, setInputState] = useState<TypeStatusDeclaration>(props.decTVA.state);

    const handleSubmit = () => {
        UpdateChangeStatusDeclarationTVA(getIdWithToken(), {
            month: props.decTVA.month,
            year: props.decTVA.year,
            state: inputState
        }).then(() => {
            toast.success("Statut TVA mis à jour.", "Déclaration TVA");
            props.onFinished();
        }).catch((err) => props.onError(err));
    }

    const tva = props.decTVA.tva;

    return (
        <form className="fcaForm" onSubmit={(e) => e.preventDefault()}>
            {/* Carte récap */}
            <div className="fcaSummaryCard">
                <div className="fcaSummaryHeader">
                    <span className="material-symbols-outlined">receipt_long</span>
                    <div>
                        <div className="fcaSummaryTitle">{TypeDate.monthsLong[props.decTVA.month]} {props.decTVA.year}</div>
                        <div className="fcaSummarySubtitle">Déclaration mensuelle de TVA</div>
                    </div>
                </div>
                <div className="fcaSummaryGrid">
                    <div className="fcaSummaryItem">
                        <span className="fcaSummaryItemLabel">CA à déclarer</span>
                        <span className="fcaSummaryItemValue">{formatEuro(tva?.ca ?? 0)}</span>
                    </div>
                    <div className="fcaSummaryItem">
                        <span className="fcaSummaryItemLabel">TVA nette due</span>
                        <span className="fcaSummaryItemValueGold">{formatEuro(Math.round(tva?.vatDeclared ?? 0))}</span>
                    </div>
                </div>
            </div>

            {/* Sélecteur de statut */}
            <div className="fcaSection">
                <div className="fcaSectionLabel">Statut de la déclaration</div>
                <div className="fcaStatusToggle" role="radiogroup" aria-label="Statut de la déclaration">
                    {StatusDeclaration.ListStatus.map((s) => {
                        const isActive = inputState === s;
                        return (
                            <button
                                key={s}
                                type="button"
                                role="radio"
                                aria-checked={isActive}
                                className={`fcaStatusOption ${isActive ? "active" : ""} ${s === TypeStatusDeclaration.DONE ? "done" : "open"}`}
                                onClick={() => setInputState(s)}
                            >
                                <span className="material-symbols-outlined">
                                    {s === TypeStatusDeclaration.DONE ? "task_alt" : "schedule"}
                                </span>
                                <span className="fcaStatusOptionLabel">{StatusDeclaration.toString(s)}</span>
                            </button>
                        );
                    })}
                </div>
            </div>

            <div className="fcaActions">
                <button type="button" className="fcaBtn fcaBtnSecondary" onClick={() => props.onFinished()}>
                    Annuler
                </button>
                <button type="button" className="fcaBtn fcaBtnPrimary" onClick={handleSubmit}>
                    <span className="material-symbols-outlined">check</span>
                    Valider
                </button>
            </div>
        </form>
    );
}

export default FormDeclarationTVA;
